"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgreementReviewForm = void 0;
exports.agreementReviewSubmissionMessage = agreementReviewSubmissionMessage;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _SearchableSelect = require("./SearchableSelect");
var _button = require("@design/ui/button");
var _card = require("@design/ui/card");
var _hoverCard = require("@design/ui/hover-card");
var _input = require("@design/ui/input");
var _select = require("@design/ui/select");
var _tabs = require("@design/ui/tabs");
var _lookupOptions = require("./lookup-options");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var ALTERNATIVE_SOURCES_CLOSE_DELAY_MS = 200;
var TITLE_CLASS = "m-0 text-label text-foreground-primary";
var REASON_CLASS = "m-0 text-body-sm text-foreground-muted";
var FIELDS_CLASS = "flex min-w-0 flex-col gap-2.5";
var ROW_CLASS = "flex min-w-0 flex-row flex-nowrap items-start gap-3 border-b border-border-default py-2";
var COLUMN_CLASS = "min-w-0 flex-1 basis-0";
var LABEL_CLASS = "mb-1 text-label-sm text-foreground-primary";
var LABEL_ROW_CLASS = "mb-1 flex items-center gap-1";
var SOURCE_HEADER_CLASS = "mb-1 text-label-sm text-foreground-muted";
var CITATION_LINK_CLASS = "text-foreground-link underline";
var SOURCE_CARD_CLASS = "w-45 flex-none";
var MUTED_NOTE_CLASS = "m-0 text-caption text-foreground-muted";
var ERROR_CLASS = "m-0 text-caption text-destructive-text";
function resolveSource(source, agreements) {
  var _ref, _source$agreement_nam, _source$agreement_dat, _source$deeplink;
  var ref = agreements === null || agreements === void 0 ? void 0 : agreements[source.agreement_sys_id];
  return {
    agreement_name: (_ref = (_source$agreement_nam = source.agreement_name) !== null && _source$agreement_nam !== void 0 ? _source$agreement_nam : ref === null || ref === void 0 ? void 0 : ref.agreement_name) !== null && _ref !== void 0 ? _ref : source.agreement_sys_id,
    agreement_date: (_source$agreement_dat = source.agreement_date) !== null && _source$agreement_dat !== void 0 ? _source$agreement_dat : ref === null || ref === void 0 ? void 0 : ref.agreement_date,
    deeplink: (_source$deeplink = source.deeplink) !== null && _source$deeplink !== void 0 ? _source$deeplink : ref === null || ref === void 0 ? void 0 : ref.deeplink
  };
}
function initialValues(fields) {
  var values = {};
  var _iterator = _createForOfIteratorHelper(fields),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _field$value;
      var field = _step.value;
      values[field.name] = (_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : "";
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return values;
}
function parseCurrencyValue(value, currencies) {
  var _ref2, _match$;
  var match = value.replace(/,/g, "").match(/^(-?[\d.]+)\s*([A-Za-z]{3})?$/);
  return {
    amount: match ? match[1] : "",
    currency: ((_ref2 = (_match$ = match === null || match === void 0 ? void 0 : match[2]) !== null && _match$ !== void 0 ? _match$ : currencies[0]) !== null && _ref2 !== void 0 ? _ref2 : "").toUpperCase()
  };
}
function formatCurrencyValue(amount, currency) {
  return amount ? "".concat(amount, " ").concat(currency).trim() : "";
}
function hasCaveatFreeValue(field, value, resolvedOptions) {
  var _field$value2, _field$options, _field$sources, _field$alternatives;
  if (field.type !== "enum") return true;
  if (value === ((_field$value2 = field.value) !== null && _field$value2 !== void 0 ? _field$value2 : "")) return true;
  if (((_field$options = field.options) !== null && _field$options !== void 0 ? _field$options : []).includes(value)) return true;
  if ((resolvedOptions !== null && resolvedOptions !== void 0 ? resolvedOptions : []).includes(value)) return true;
  if (((_field$sources = field.sources) !== null && _field$sources !== void 0 ? _field$sources : []).some(function (source) {
    return source.value === value;
  })) return true;
  if (((_field$alternatives = field.alternatives) !== null && _field$alternatives !== void 0 ? _field$alternatives : []).some(function (alt) {
    return alt.value === value;
  })) return true;
  return false;
}
function customValueCaveat(field, value, resolvedOptions) {
  var _field$options2;
  if (hasCaveatFreeValue(field, value, resolvedOptions)) return "";
  if (field.strict) return " (custom value — outside the closed option list; may not be accepted on save)";
  var hasInlineOptions = !!((_field$options2 = field.options) !== null && _field$options2 !== void 0 && _field$options2.length);
  if (!hasInlineOptions && field.options_url) {
    return " (custom value — not found in existing Icertis records; may need to be created there before this can be saved)";
  }
  return "";
}
function agreementReviewSubmissionMessage(title, fields, values, formId, resolvedOptionsByField) {
  var lines = fields.map(function (field) {
    var _values$field$name;
    var value = (_values$field$name = values[field.name]) === null || _values$field$name === void 0 ? void 0 : _values$field$name.trim();
    return value ? "- ".concat(field.label, ": ").concat(value).concat(customValueCaveat(field, value, resolvedOptionsByField === null || resolvedOptionsByField === void 0 ? void 0 : resolvedOptionsByField[field.name])) : null;
  }).filter(function (line) {
    return line !== null;
  });
  var summary = title ? "".concat(title, ":\n").concat(lines.join("\n")) : lines.join("\n");
  return formId ? "".concat(summary, "\n\n<scroll-to-form id=\"").concat(formId, "\"></scroll-to-form>") : summary;
}
function isFieldAnswered(field, values) {
  var _values$field$name2;
  return !field.required || !!((_values$field$name2 = values[field.name]) !== null && _values$field$name2 !== void 0 && _values$field$name2.trim());
}
var AGREEMENT_DATE_LOCALE = "en-US";
var AGREEMENT_DATE_FORMAT = {
  year: "numeric",
  month: "short",
  day: "numeric",
  timeZone: "UTC"
};
function formatAgreementDate(date) {
  if (!date) return null;
  var parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return date;
  return parsed.toLocaleDateString(AGREEMENT_DATE_LOCALE, AGREEMENT_DATE_FORMAT);
}
function uniqueBy(items, key) {
  var seen = new Set();
  return items.filter(function (item) {
    var k = key(item);
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}
function uniqueByValue(sources) {
  return uniqueBy(sources, function (source) {
    return source.value;
  });
}
function uniqueByAgreement(sources) {
  return uniqueBy(sources, function (source) {
    return source.agreement_sys_id;
  });
}
function matchesForValue(field, value) {
  var _field$sources2, _field$alternatives2;
  var fromSources = ((_field$sources2 = field.sources) !== null && _field$sources2 !== void 0 ? _field$sources2 : []).filter(function (source) {
    return source.value === value;
  });
  var fromAlternatives = ((_field$alternatives2 = field.alternatives) !== null && _field$alternatives2 !== void 0 ? _field$alternatives2 : []).filter(function (alt) {
    return alt.value === value;
  });
  return uniqueByAgreement([].concat(_toConsumableArray(fromSources), _toConsumableArray(fromAlternatives)));
}
var EnumInput = function EnumInput(_ref3) {
  var _field$options3, _field$options4;
  var field = _ref3.field,
    controlId = _ref3.controlId,
    value = _ref3.value,
    _onChange = _ref3.onChange,
    fetchLookupOptions = _ref3.fetchLookupOptions,
    onResolved = _ref3.onResolved;
  var hasInlineOptions = !!((_field$options3 = field.options) !== null && _field$options3 !== void 0 && _field$options3.length);
  var _useLookupOptions = (0, _lookupOptions.useLookupOptions)(hasInlineOptions ? null : field.options_url, fetchLookupOptions),
    fetchedOptions = _useLookupOptions.options,
    isLoading = _useLookupOptions.isLoading,
    loadError = _useLookupOptions.loadError;
  var options = (_field$options4 = field.options) !== null && _field$options4 !== void 0 && _field$options4.length ? field.options : fetchedOptions;
  var allowCustom = !field.strict;
  var isCustomValue = !!value && !options.includes(value);
  (0, _react.useEffect)(function () {
    if (!hasInlineOptions && fetchedOptions.length) onResolved === null || onResolved === void 0 || onResolved(field.name, fetchedOptions);
  }, [hasInlineOptions, fetchedOptions, onResolved, field.name]);
  if (isLoading) return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    role: "status",
    className: MUTED_NOTE_CLASS,
    children: "Loading options\u2026"
  });
  if (loadError) return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    role: "alert",
    className: ERROR_CLASS,
    children: loadError
  });
  var customRow = allowCustom ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "mt-0.5 flex min-w-0 items-center gap-1.5",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "shrink-0 whitespace-nowrap text-caption text-foreground-muted",
      children: "Or enter a custom value:"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
      className: "flex-1",
      type: "text",
      value: isCustomValue ? value : "",
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      }
    }), !hasInlineOptions && isCustomValue ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_lookupOptions.StrictFieldInfoTooltip, {
      text: "Not found in existing Icertis records \u2014 this value may need to be created there before it can be saved."
    }) : null]
  }) : null;
  if (field.quick_select) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col gap-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex flex-wrap gap-1.5",
        children: options.map(function (option) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: value === option ? "secondary" : "outline",
            size: "xs",
            "aria-pressed": value === option,
            onClick: function onClick() {
              return _onChange(option);
            },
            children: option
          }, option);
        })
      }), customRow]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex min-w-0 items-center gap-1.5",
    "data-sentry-component": "EnumInput",
    "data-sentry-source-file": "AgreementReviewForm.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "min-w-0 flex-auto",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchableSelect.SearchableSelect, {
        id: controlId,
        options: options.map(function (label) {
          return {
            label: label
          };
        }),
        selected: options.includes(value) ? [options.indexOf(value)] : [],
        multiSelect: false,
        onToggle: function onToggle(index) {
          var _options$index;
          return _onChange((_options$index = options[index]) !== null && _options$index !== void 0 ? _options$index : "");
        },
        onCustomValue: allowCustom ? _onChange : undefined,
        customDisplayValue: value,
        label: "Search ".concat(field.label, " options"),
        "data-sentry-element": "SearchableSelect",
        "data-sentry-source-file": "AgreementReviewForm.tsx"
      })
    }), !hasInlineOptions && isCustomValue ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_lookupOptions.StrictFieldInfoTooltip, {
      text: "Not found in existing Icertis records \u2014 this value may need to be created there before it can be saved."
    }) : null]
  });
};
var ReviewFieldInput = function ReviewFieldInput(_ref4) {
  var field = _ref4.field,
    controlId = _ref4.controlId,
    value = _ref4.value,
    _onChange2 = _ref4.onChange,
    fetchLookupOptions = _ref4.fetchLookupOptions,
    onResolved = _ref4.onResolved;
  if (field.type === "enum") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(EnumInput, {
      field: field,
      controlId: controlId,
      value: value,
      onChange: _onChange2,
      fetchLookupOptions: fetchLookupOptions,
      onResolved: onResolved
    });
  }
  if (field.type === "currency") {
    var _field$currencies, _field$currencies2;
    var _parseCurrencyValue = parseCurrencyValue(value, (_field$currencies = field.currencies) !== null && _field$currencies !== void 0 ? _field$currencies : []),
      amount = _parseCurrencyValue.amount,
      currency = _parseCurrencyValue.currency;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex gap-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
        id: controlId,
        className: "flex-1",
        type: "number",
        value: amount,
        onChange: function onChange(e) {
          return _onChange2(formatCurrencyValue(e.target.value, currency));
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
        value: currency,
        onValueChange: function onValueChange(nextCurrency) {
          return _onChange2(formatCurrencyValue(amount, nextCurrency));
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
          "aria-label": "".concat(field.label, " currency"),
          className: "w-22",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectContent, {
          children: _toConsumableArray(new Set([].concat(_toConsumableArray((_field$currencies2 = field.currencies) !== null && _field$currencies2 !== void 0 ? _field$currencies2 : []), [currency]))).filter(Boolean).map(function (c) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
              value: c,
              children: c
            }, c);
          })
        })]
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
    id: controlId,
    type: field.type === "date" ? "date" : field.type === "number" ? "number" : "text",
    value: value,
    onChange: function onChange(e) {
      return _onChange2(e.target.value);
    },
    "data-sentry-element": "Input",
    "data-sentry-component": "ReviewFieldInput",
    "data-sentry-source-file": "AgreementReviewForm.tsx"
  });
};
var ViewToggle = function ViewToggle(_ref5) {
  var view = _ref5.view,
    onChange = _ref5.onChange;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tabs.Tabs, {
    value: view,
    onValueChange: function onValueChange(nextView) {
      return onChange(nextView);
    },
    "data-sentry-element": "Tabs",
    "data-sentry-component": "ViewToggle",
    "data-sentry-source-file": "AgreementReviewForm.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_tabs.TabsList, {
      "aria-label": "Review layout",
      "data-sentry-element": "TabsList",
      "data-sentry-source-file": "AgreementReviewForm.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_tabs.TabsTrigger, {
        value: "suggested",
        "data-sentry-element": "TabsTrigger",
        "data-sentry-source-file": "AgreementReviewForm.tsx",
        children: "Suggested"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_tabs.TabsTrigger, {
        value: "by_source",
        "data-sentry-element": "TabsTrigger",
        "data-sentry-source-file": "AgreementReviewForm.tsx",
        children: "By source"
      })]
    })
  });
};
var SuggestedRow = function SuggestedRow(_ref6) {
  var _field$value3, _field$alternatives3;
  var field = _ref6.field,
    value = _ref6.value,
    onChange = _ref6.onChange,
    agreements = _ref6.agreements,
    fetchLookupOptions = _ref6.fetchLookupOptions,
    onResolved = _ref6.onResolved;
  var suggested = (_field$value3 = field.value) !== null && _field$value3 !== void 0 ? _field$value3 : "";
  var isOverridden = value !== suggested;
  var controlId = "".concat(field.name, "-control");
  var uniqueAlternatives = uniqueByValue((_field$alternatives3 = field.alternatives) !== null && _field$alternatives3 !== void 0 ? _field$alternatives3 : []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: ROW_CLASS,
    "data-sentry-component": "SuggestedRow",
    "data-sentry-source-file": "AgreementReviewForm.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: COLUMN_CLASS,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: LABEL_ROW_CLASS,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
          className: LABEL_CLASS,
          htmlFor: controlId,
          children: [field.label, field.required ? " *" : ""]
        }), field.strict ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_lookupOptions.StrictFieldInfoTooltip, {
          text: _lookupOptions.STRICT_TOOLTIP_TEXT
        }) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ReviewFieldInput, {
        field: field,
        controlId: controlId,
        value: value,
        onChange: onChange,
        fetchLookupOptions: fetchLookupOptions,
        onResolved: onResolved,
        "data-sentry-element": "ReviewFieldInput",
        "data-sentry-source-file": "AgreementReviewForm.tsx"
      }), isOverridden ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
        type: "button",
        variant: "link",
        size: "xs",
        className: "mt-1",
        onClick: function onClick() {
          return onChange(suggested);
        },
        children: "Reset to suggested"
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: COLUMN_CLASS,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: SOURCE_HEADER_CLASS,
        children: "Matches"
      }), function () {
        var matches = matchesForValue(field, value);
        if (!matches.length) return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "text-caption text-foreground-muted",
          children: "No prior agreement matches this value."
        });
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
          className: "m-0 flex flex-col gap-1 pl-4 text-caption text-foreground-muted",
          children: matches.slice(0, 3).map(function (source) {
            var resolved = resolveSource(source, agreements);
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
              children: [resolved.deeplink ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                href: resolved.deeplink,
                target: "_blank",
                rel: "noopener noreferrer",
                className: CITATION_LINK_CLASS,
                children: resolved.agreement_name
              }) : resolved.agreement_name, formatAgreementDate(resolved.agreement_date) ? " \u2014 ".concat(formatAgreementDate(resolved.agreement_date)) : null]
            }, source.agreement_sys_id);
          })
        });
      }()]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: COLUMN_CLASS,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: SOURCE_HEADER_CLASS,
        children: "Alternatives"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex flex-wrap gap-1.5",
        children: uniqueAlternatives.map(function (alt) {
          var _field$sources3;
          var matchingSources = uniqueByAgreement(((_field$sources3 = field.sources) !== null && _field$sources3 !== void 0 ? _field$sources3 : []).filter(function (source) {
            return source.value === alt.value;
          }));
          var tooltipItems = matchingSources.length ? matchingSources : [alt];
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_hoverCard.HoverCard, {
            openDelay: 0,
            closeDelay: ALTERNATIVE_SOURCES_CLOSE_DELAY_MS,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverCard.HoverCardTrigger, {
              asChild: true,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
                type: "button",
                variant: value === alt.value ? "secondary" : "outline",
                size: "xs",
                "aria-pressed": value === alt.value,
                onClick: function onClick() {
                  return onChange(value === alt.value ? suggested : alt.value);
                },
                children: alt.value
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverCard.HoverCardContent, {
              side: "top",
              className: "flex w-55 flex-col gap-1 p-2 text-xs",
              children: tooltipItems.map(function (source) {
                var resolved = resolveSource(source, agreements);
                return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  children: [resolved.deeplink ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                    href: resolved.deeplink,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: CITATION_LINK_CLASS,
                    children: resolved.agreement_name
                  }) : resolved.agreement_name, formatAgreementDate(resolved.agreement_date) ? " \u2014 ".concat(formatAgreementDate(resolved.agreement_date)) : ""]
                }, source.agreement_sys_id);
              })
            })]
          }, alt.value);
        })
      })]
    })]
  });
};
var BySourceRow = function BySourceRow(_ref7) {
  var _field$sources4;
  var field = _ref7.field,
    value = _ref7.value,
    onChange = _ref7.onChange,
    agreements = _ref7.agreements,
    fetchLookupOptions = _ref7.fetchLookupOptions,
    onResolved = _ref7.onResolved;
  var sources = (_field$sources4 = field.sources) !== null && _field$sources4 !== void 0 ? _field$sources4 : [];
  var controlId = "".concat(field.name, "-control");
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _utils.cn)(ROW_CLASS, "w-full"),
    "data-sentry-component": "BySourceRow",
    "data-sentry-source-file": "AgreementReviewForm.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "min-w-0 flex-none basis-2/5",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: LABEL_ROW_CLASS,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
          className: LABEL_CLASS,
          htmlFor: controlId,
          children: [field.label, field.required ? " *" : ""]
        }), field.strict ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_lookupOptions.StrictFieldInfoTooltip, {
          text: _lookupOptions.STRICT_TOOLTIP_TEXT
        }) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ReviewFieldInput, {
        field: field,
        controlId: controlId,
        value: value,
        onChange: onChange,
        fetchLookupOptions: fetchLookupOptions,
        onResolved: onResolved,
        "data-sentry-element": "ReviewFieldInput",
        "data-sentry-source-file": "AgreementReviewForm.tsx"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex min-w-0 flex-auto gap-2 overflow-x-auto pb-1 focus-ring-room-x",
      children: sources.length ? sources.map(function (source) {
        var resolved = resolveSource(source, agreements);
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: SOURCE_CARD_CLASS,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: SOURCE_HEADER_CLASS,
            children: [resolved.deeplink ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
              href: resolved.deeplink,
              target: "_blank",
              rel: "noopener noreferrer",
              className: CITATION_LINK_CLASS,
              children: resolved.agreement_name
            }) : resolved.agreement_name, formatAgreementDate(resolved.agreement_date) ? " \u2014 ".concat(formatAgreementDate(resolved.agreement_date)) : null]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: value === source.value ? "secondary" : "outline",
            size: "xs",
            "aria-pressed": value === source.value,
            className: "h-auto w-full justify-start py-1 text-left whitespace-normal",
            onClick: function onClick() {
              return onChange(value === source.value ? "" : source.value);
            },
            children: source.value
          })]
        }, source.agreement_sys_id);
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)(SOURCE_CARD_CLASS, "rounded-md border border-border px-2 py-1 text-caption text-foreground-muted"),
        children: "No prior agreements"
      })
    })]
  });
};
var LockedFields = function LockedFields(_ref8) {
  var title = _ref8.title,
    fields = _ref8.fields,
    reason = _ref8.reason,
    values = _ref8.values;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: TITLE_CLASS,
      children: title
    }) : null, reason ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: REASON_CLASS,
      children: reason
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: FIELDS_CLASS,
      children: fields.map(function (field) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col gap-1",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            className: LABEL_CLASS,
            children: [field.label, field.required ? " *" : ""]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: MUTED_NOTE_CLASS,
            children: values[field.name] || "—"
          })]
        }, field.name);
      })
    })]
  });
};
var AgreementReviewForm = exports.AgreementReviewForm = function AgreementReviewForm(_ref9) {
  var title = _ref9.title,
    fields = _ref9.fields,
    reason = _ref9.reason,
    agreements = _ref9.agreements,
    defaultView = _ref9.defaultView,
    sendMessage = _ref9.sendMessage,
    answer = _ref9.answer,
    readOnly = _ref9.readOnly,
    onSubmitted = _ref9.onSubmitted,
    formId = _ref9.formId,
    fetchLookupOptions = _ref9.fetchLookupOptions;
  var _useState = (0, _react.useState)(defaultView !== null && defaultView !== void 0 ? defaultView : "suggested"),
    _useState2 = _slicedToArray(_useState, 2),
    view = _useState2[0],
    setView = _useState2[1];
  var _useState3 = (0, _react.useState)(function () {
      return initialValues(fields);
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    values = _useState4[0],
    setValues = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSubmitting = _useState6[0],
    setIsSubmitting = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    submitted = _useState8[0],
    setSubmitted = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    submitError = _useState0[0],
    setSubmitError = _useState0[1];
  var submittedRef = (0, _react.useRef)(false);
  var resolvedOptionsRef = (0, _react.useRef)({});
  var rememberResolvedOptions = (0, _react.useCallback)(function (fieldName, options) {
    resolvedOptionsRef.current[fieldName] = options;
  }, []);
  var setField = function setField(name, value) {
    return setValues(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, value));
    });
  };
  var allRequiredAnswered = fields.every(function (field) {
    return isFieldAnswered(field, values);
  });
  var canSubmit = allRequiredAnswered && !isSubmitting && !submittedRef.current;
  var handleSubmit = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var sent, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(!canSubmit || !sendMessage)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setIsSubmitting(true);
            setSubmitError(null);
            _context.p = 2;
            _context.n = 3;
            return sendMessage(agreementReviewSubmissionMessage(title, fields, values, formId, resolvedOptionsRef.current));
          case 3:
            sent = _context.v;
            if (sent) {
              _context.n = 4;
              break;
            }
            setSubmitError("Could not submit your reviewed values. Please try again.");
            return _context.a(2);
          case 4:
            submittedRef.current = true;
            _context.n = 5;
            return onSubmitted === null || onSubmitted === void 0 ? void 0 : onSubmitted(values);
          case 5:
            setSubmitted(values);
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
            setSubmitError("Could not submit your reviewed values. Please try again.");
          case 7:
            _context.p = 7;
            setIsSubmitting(false);
            return _context.f(7);
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[2, 6, 7, 8]]);
    }));
    return function handleSubmit() {
      return _ref0.apply(this, arguments);
    };
  }();
  var lockedValues = answer !== null && answer !== void 0 ? answer : submitted;
  if (readOnly || lockedValues) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.Card, {
      id: formId,
      size: "sm",
      className: "my-2 min-w-0",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardContent, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LockedFields, {
          title: title,
          fields: fields,
          reason: reason,
          values: lockedValues !== null && lockedValues !== void 0 ? lockedValues : values
        })
      })
    });
  }
  var submitErrorEl = submitError ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: ERROR_CLASS,
    children: submitError
  }) : null;
  var FieldRow = view === "suggested" ? SuggestedRow : BySourceRow;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.Card, {
    id: formId,
    size: "sm",
    className: "my-2 min-w-0",
    "data-sentry-element": "Card",
    "data-sentry-component": "AgreementReviewForm",
    "data-sentry-source-file": "AgreementReviewForm.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardContent, {
      "data-sentry-element": "CardContent",
      "data-sentry-source-file": "AgreementReviewForm.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-start justify-between gap-3",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col gap-1",
          children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: TITLE_CLASS,
            children: title
          }) : null, reason ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: REASON_CLASS,
            children: reason
          }) : null]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ViewToggle, {
          view: view,
          onChange: setView,
          "data-sentry-element": "ViewToggle",
          "data-sentry-source-file": "AgreementReviewForm.tsx"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("fieldset", {
        className: "m-0 flex min-w-0 flex-col gap-3 border-none p-0",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: FIELDS_CLASS,
          children: fields.map(function (field) {
            var _values$field$name3;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(FieldRow, {
              field: field,
              value: (_values$field$name3 = values[field.name]) !== null && _values$field$name3 !== void 0 ? _values$field$name3 : "",
              onChange: function onChange(value) {
                return setField(field.name, value);
              },
              agreements: agreements,
              fetchLookupOptions: fetchLookupOptions,
              onResolved: rememberResolvedOptions
            }, field.name);
          })
        }), submitErrorEl, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex justify-end gap-2",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            size: "sm",
            onClick: handleSubmit,
            disabled: !canSubmit,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "AgreementReviewForm.tsx",
            children: submittedRef.current ? "Submitted" : "Submit"
          })
        })]
      })]
    })
  });
};